import { getPageType } from '../_helpers/getPageType'

// GTM stuff for Google Ads
export function wireGoogleAds(app) {
    app.$uiEvents.$on('firstLoaded', emitRemarketingPageView)
    app.$uiEvents.$on('routeChanged', emitRemarketingPageView)

    function emitRemarketingPageView({ to }) {
        const pageType = getPageType(to.name)
        const state = app.store.state
        let params = null

        if (
            (pageType == 'product-line' || pageType == 'sku') &&
            state.product.data &&
            state.product.data.googleProductId
        ) {
            const categories = getCategoryTree(state.product.data.crumbs)
            categories.pop() // last crumb is the line/sku

            params = {
                ecomm_pagetype: pageType,
                ecomm_prodid: state.product.data.googleProductId,
                ecomm_totalvalue: state.product.data.actualPrice.min / 100, // for plines does this need to match the 'sample' sku?  Doesn't really seem like it
                brand: state.product.data.brand.name,
                category: categories,
            }
        }

        if (pageType == 'category' && state.catalog.data) {
            params = {
                ecomm_pagetype: pageType,
                category: getCategoryTree(state.catalog.data.crumbs),
            }
        }

        if (pageType == 'brand' && state.catalog.data) {
            params = {
                ecomm_pagetype: pageType,
                brand: state.catalog.data.name,
            }
        }

        if (pageType == 'mmy' || pageType == 'home') {
            params = {
                ecomm_pagetype: pageType,
            }
        }

        if (params == null) return

        if (state.fitment.data.make) params.make = state.fitment.data.make
        if (state.fitment.data.model) params.model = state.fitment.data.model
        if (state.fitment.data.year) params.year = state.fitment.data.year

        // GTM merges junk so you have to send null to reset it
        // https://stackoverflow.com/questions/33942649/why-is-gtm-concatenating-object-values-in-datalayer
        // https://www.bounteous.com/insights/2016/03/21/removing-values-in-the-datalayer/
        window.dataLayer.push({
            google_tag_params: null,
        })

        window.dataLayer.push({
            event: 'custom.event.remarketingPageView',
            google_tag_params: params,
        })
    }
}

// since we don't have a 'real' category tree obj, we'll have to leverage crumbs :(
// note: this may contain different category verbiage than real life (UWP = Folding vs classic RT = Folding Tonneau Covers)
function getCategoryTree(crumbs) {
    if (!crumbs || crumbs.length < 2) return

    const arr = []
    crumbs.forEach((crumb, index) => {
        // skip 'Home'
        if (index > 0) arr.push(crumb.title)
    })

    return arr
}
